import {
  AccountEstablishRequestParam,
  findFinancialIntermediaryId,
  findFinancialIntermediaryCenterId,
  finedNationalityId,
  finedPofessionId,
  finedListedCompanyPostId,
  finedExperiencesIds,
  finedPolicyId,
  finedPurposesIds,
  finedAnnualIncomeId,
  finedIncomeFormIds,
  finedFinancialAssetsId,
  getSexTypeStr,
  getDepositType,
  ListedCompanyPost,
} from 'views/utils/accountEstablish';
import { AccountInfoUpdateRequestParam } from 'views/components/pages/accountInfo/hooks/useUpdatePage';

/*--------------
  確認画面
  --------------*/

type ComfirmDisp = {
  title: string;
  value: string | string[];
  visible: boolean;
};
export type ComfirmGroup = {
  header: string;
  onClick: () => void;
  dispList: ComfirmDisp[];
};

////APIリクエストパラメータ作成
//事前質問
export const addvanceQuestionParam = (param: AccountEstablishRequestParam) => {
  return {
    FinancialIntermediaryInvitation: param.financialIntermediaryInvitation
      ? param.financialIntermediaryInvitation
      : false,
    FinancialIntermediaryExplanation: param.financialIntermediaryExplanation
      ? param.financialIntermediaryExplanation
      : false,
    FinancialIntermediary: findFinancialIntermediaryId(String(param.financialIntermediary)),
    FinancialIntermediaryCenter: findFinancialIntermediaryCenterId(String(param.financialIntermediaryCenter)),
    ManagerCode: param.managerCode,
    AgeConfirmation: param.ageConfirmation,
    ResidenceConfirmation: param.residenceConfirmation,
    IDConfirmation: param.idConfirmation,
    PEPsConfirmation: param.pepsConfirmation,
    ElectronicDocumentAgreement: param.electronicDocumentAgreement,
    ElectronicDocumentAgreementDateTime: param.electronicDocumentAgreementDateTime,
  };
};

//証券同意
export const consentSecuritiesParam = (param: AccountEstablishRequestParam) => {
  return {
    SecuritiesTradingTermsAgreement: param.securitiesTradingTermsAgreement,
    PreContractAgreement: param.preContractAgreement,
    InformationSharingAgreement: param.informationSharingAgreement,
    AntiSocialForcesCheckAgreement: param.antiSocialForcesCheckAgreement,
  };
};

//信託同意
export const consentTrustParam = (param: AccountEstablishRequestParam) => {
  return {
    DistributionStatementAgreement: param.distributionStatementAgreement,
  };
};

//お客様情報
export const costomerInfoParam = (param: AccountEstablishRequestParam | AccountInfoUpdateRequestParam) => {
  return {
    Nationality: Number(finedNationalityId(param.nationality)),
    AmericanOnTaxSystem: param.americanOnTaxSystem,
    SSN: param.ssn,
    ITIN: param.itin,
    FATCAAgreement: param.fatcaAgreement,
    FATCAOath: param.fatcaOath,
    FirstName: param.firstName,
    LastName: param.lastName,
    FirstNameKana: param.firstNameKana,
    LastNameKana: param.lastNameKana,
    Birthday: param.birthday,
    Sex: Number(param.sex),
    PostCode: param.postCode,
    Prefecture: param.prefecture,
    CityCounty: param.cityCounty,
    TownStreetAddress: param.townStreetAddress,
    BuildingNameRoomNumber: param.buildingNameRoomNumber,
    MobilePhoneNumber: param.mobilePhoneNumber,
    HomePhoneNumber: param.homePhoneNumber,
    MailAddress: param.mailAddress,
  };
};

//指定預金口座情報
export const depositAccountParam = (param: AccountEstablishRequestParam | AccountInfoUpdateRequestParam) => {
  return {
    BankCode: param.isYuchoBank ? param.bankCodeOfYucho : param.bankCode,
    BranchCode: param.isYuchoBank ? param.branchCodeOfYucho : param.branchCode,
    AccountNumber: param.isYuchoBank ? param.accountNumberOfYucho : param.accountNumber,
    DepositForm: param.isYuchoBank ? param.depositFormOfYucho : param.depositForm,
  };
};

//お勤め先情報
export const employmentParam = (param: AccountEstablishRequestParam | AccountInfoUpdateRequestParam) => {
  return {
    Profession: Number(finedPofessionId(param.profession)),
    Workplace: param.workplace,
    Department: param.department,
    Post: param.post,
    WorkPhoneNumber: param.workPhoneNumber,
    ListedCompanyCheck: param.listedCompanyCheck,
    ListedCompanyPost: param.listedCompanyCheck
      ? Number(finedListedCompanyPostId(String(param.listedCompanyPost)))
      : null,
    ListedCompanyName: param.listedCompanyCheck ? param.listedCompanyName : null,
    OutSidePost:
      param.listedCompanyCheck && param.listedCompanyPost !== ListedCompanyPost.OFFICER_FAMIRY
        ? param.outSidePost
        : null,
    RetirementDate:
      param.listedCompanyCheck && param.listedCompanyPost !== ListedCompanyPost.OFFICER_FAMIRY
        ? param.retirementDate
        : null,
    InsiderBoardMemberFirstName:
      param.listedCompanyCheck && param.listedCompanyPost === ListedCompanyPost.OFFICER_FAMIRY
        ? param.insiderBoardMemberFirstName
        : null,
    InsiderBoardMemberLastName:
      param.listedCompanyCheck && param.listedCompanyPost === ListedCompanyPost.OFFICER_FAMIRY
        ? param.insiderBoardMemberLastName
        : null,
  };
};

//投資情報
export const investmentInfoParam = (param: AccountEstablishRequestParam | AccountInfoUpdateRequestParam) => {
  return {
    InvestmentExperiences: finedExperiencesIds(param.investmentExperiences),
    InvestmentPolicy: Number(finedPolicyId(String(param.investmentPolicy))),
    InvestmentPurposes: finedPurposesIds(param.investmentPurposes),
    AnnualIncome: Number(finedAnnualIncomeId(String(param.annualIncome))),
    IncomeForm: finedIncomeFormIds(param.incomeForm),
    FinancialAssets: Number(finedFinancialAssetsId(String(param.financialAssets))),
  };
};

//確認画面表示用パラメータ
const getDepositFormStr = (isYucho: boolean, depositForm: number): string => {
  if (isYucho) {
    return getDepositType(depositForm) ? '普通預金' : '貯蓄預金';
  } else {
    return getDepositType(depositForm) ? '普通(総合)' : '当座';
  }
};

//お客様情報
export const costomerInfoDispParam = (
  param: AccountEstablishRequestParam | AccountInfoUpdateRequestParam,
  onClickFunc: () => void,
  isUpdate: boolean,
) => {
  return {
    header: 'お客様情報',
    onClick: onClickFunc,
    dispList: [
      { title: '国籍', value: param.nationality, visible: true },
      {
        title: '米国税法上の米国人（米国永住権保持者等）に該当しますか？',
        value: !!param.americanOnTaxSystem ? 'はい' : 'いいえ',
        visible: true,
      },
      {
        title: 'SSN (米国社会保障番号)',
        value: String(param.ssn ?? ''),
        visible: !!param.americanOnTaxSystem,
      },
      {
        title: 'ITIN (米国納税者番号)',
        value: String(param.itin ?? ''),
        visible: !!param.americanOnTaxSystem,
      },
      {
        title: '氏名',
        value: param.lastName + param.firstName,
        visible: true,
      },
      {
        title: '氏名（フリガナ）',
        value: param.lastNameKana + param.firstNameKana,
        visible: true,
      },
      { title: '生年月日', value: param.birthday, visible: !isUpdate },
      { title: '性別', value: getSexTypeStr(param.sex) ?? '', visible: !isUpdate },
      { title: '郵便番号', value: param.postCode, visible: true },
      {
        title: '住所',
        value: param.prefecture + param.cityCounty + param.townStreetAddress + (param.buildingNameRoomNumber || ''),
        visible: true,
      },
      {
        title: '携帯電話番号',
        value: param.mobilePhoneNumber,
        visible: true,
      },
      {
        title: '自宅電話番号',
        value: param.homePhoneNumber || '',
        visible: true,
      },
      { title: 'メールアドレス', value: param.mailAddress, visible: true },
    ],
  };
};

//指定預金口座情報
export const depositAccountDispParam = (
  param: AccountEstablishRequestParam | AccountInfoUpdateRequestParam,
  onClickFunc: () => void,
) => {
  return {
    header: '指定預金口座情報',
    onClick: onClickFunc,
    dispList: [
      {
        title: '指定預金口座としてゆうちょ銀行をご利用されますか？',
        value: param.isYuchoBank ? 'はい' : 'いいえ',
        visible: true,
      },
      {
        title: '銀行コード',
        value: param.isYuchoBank ? param.bankCodeOfYucho : param.bankCode,
        visible: true,
      },
      {
        title: '金融機関名',
        value: param.isYuchoBank ? param.bankNameOfYucho : param.bankName,
        visible: true,
      },
      {
        title: '店番号',
        value: param.isYuchoBank ? param.branchCodeOfYucho : param.branchCode,
        visible: true,
      },
      {
        title: '支店名',
        value: param.isYuchoBank ? param.branchNameOfYucho : param.branchName,
        visible: true,
      },
      {
        title: '銀行口座番号',
        value: param.isYuchoBank ? param.accountNumberOfYucho : param.accountNumber,
        visible: true,
      },
      {
        title: '預金種目',
        value: getDepositFormStr(param.isYuchoBank, param.depositForm),
        visible: true,
      },
    ],
  };
};

//お勤め先情報
export const employmentDispParam = (
  param: AccountEstablishRequestParam | AccountInfoUpdateRequestParam,
  onClickFunc: () => void,
) => {
  return {
    header: 'お勤め先情報',
    onClick: onClickFunc,
    dispList: [
      {
        title: 'ご職業',
        value: param.profession,
        visible: true,
      },
      {
        title: 'お勤め先名称',
        value: param.workplace,
        visible: true,
      },
      {
        title: '所属部署',
        value: param.department,
        visible: true,
      },
      {
        title: 'ご役職',
        value: param.post,
        visible: true,
      },
      {
        title: 'お勤め先電話番号',
        value: param.workPhoneNumber,
        visible: true,
      },
      {
        title: '上場会社該当者チェック',
        value: param.listedCompanyCheck ? '該当する' : '該当しない',
        visible: true,
      },
      {
        title: '上場会社等の役職等',
        value: String(param.listedCompanyPost ?? ''),
        visible: param.listedCompanyCheck,
      },
      {
        title: '上場会社名',
        value: String(param.listedCompanyName ?? ''),
        visible: param.listedCompanyCheck,
      },
      {
        title: '社外役員の場合のご役職',
        value: String(param.outSidePost ?? ''),
        visible: param.listedCompanyCheck && param.listedCompanyPost !== ListedCompanyPost.OFFICER_FAMIRY,
      },
      {
        title: '退任日',
        value: String(param.retirementDate ?? ''),
        visible: param.listedCompanyCheck && param.listedCompanyPost !== ListedCompanyPost.OFFICER_FAMIRY,
      },
      {
        title: '役員（同居または伴侶）の氏名',
        value: String(param.insiderBoardMemberLastName ?? '') + String(param.insiderBoardMemberFirstName ?? ''),
        visible: param.listedCompanyCheck && param.listedCompanyPost === ListedCompanyPost.OFFICER_FAMIRY,
      },
    ],
  };
};

//お勤め先情報
export const investmentInfoDispParam = (
  param: AccountEstablishRequestParam | AccountInfoUpdateRequestParam,
  onClickFunc: () => void,
) => {
  return {
    header: '投資情報',
    onClick: onClickFunc,
    dispList: [
      {
        title: '証券投資のご経験',
        value: param.investmentExperiences
          ?.filter((item) => item.checked)
          ?.map((data) => data.label)
          .join('／'),
        visible: true,
      },
      {
        title: 'ご投資の方針',
        value: String(param.investmentPolicy),
        visible: true,
      },
      {
        title: '弊社ご利用にあたってのご投資目的',
        value: param.investmentPurposes
          ?.filter((item) => item.checked)
          ?.map((data) => data.label)
          .join('／'),
        visible: true,
      },
      {
        title: '年収',
        value: String(param.annualIncome),
        visible: true,
      },
      {
        title: '収入形態',
        value: param.incomeForm
          ?.filter((item) => item.checked)
          ?.map((data) => data.label)
          .join('／'),
        visible: true,
      },
      {
        title: '金融資産',
        value: String(param.financialAssets),
        visible: true,
      },
    ],
  };
};
